import styled from "styled-components";

const Loader = styled.div`
  &:after {
    overflow: hidden;
    display: inline-block;

    vertical-align: bottom;
    width: 0px;
    content: "...";
    animation: ellipsis steps(4, end) 1.1s infinite;
  }

  @keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }

  @-webkit-keyframes ellipsis {
    to {
      width: 1.25em;
    }
  }
`;

export default Loader;
